import React from 'react';
import { Link } from 'react-router-dom';

export default function RelatedStory({ className, petData }) {
  const {
    ID,
    petName,
    breed,
    age,
    petType,
    content,
    images,
  } = petData;
  const regex = /(<([^>]+)>)/ig;
  return (
  <div className={`related-story posr bgc-white bdrs16 h100% oh ${ className || ''}`}>
    <div
      className="related-story__image-container dib oh posr bgc-black mb16 mih260 w100% pt100%@sm curp"
    >
      <img
        className="related-story-img h100% posa center objc w100%"
        src={(images.filter(img => img.displayImage).filter(img => img.isPrimary)[0] || images[0] || '').imageUrl}
        alt={`here is ${ petName }`}
      />
    </div>
    <div className="related-story__content pl10 pr10 pb26">
      <div className="content__name fz18@sm mb16 mb8@sm fz20 lh1.25 lts1 fw500 ttc">
        { petName }
      </div>
      <div className="content__breed-age mb16 fz14 fz12@sm lts1 fw500 ttu">
        { breed.name } &mdash; Age { age }
      </div>
      <div className="content__pet-info-preview-text fz16 fz14@sm lh1.5 mb16">
        { content.replace(regex, '').substr(0, 60) }...
      </div>
      <Link
        className="related-story__content-read-more c-black c-red:h fz16 fz14@sm fz14"
        to={`/apps/truestories/story/${ ID }`}
      >
        Read More
      </Link>
    </div>
  </div>
  )
}
